import React, { useRef, useCallback } from 'react';
import * as THREE from 'three';

import useMediaStore from '../../../../common/store/useMediaStore';
import Apple from '../../../../common/components/glb/Apple';
import useConvergeAnimation from './useConvergeAnimation';
import useFloatAnimation from './useFloatAnimation';

const SwirlApples = () => {
  const md = useMediaStore(useCallback(state => state.md, []));

  const uno = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), origin: useRef(new THREE.Vector3(-1.7, -6.8, -0.7)) };
  const dos = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), origin: useRef(new THREE.Vector3(1.24, -7.91, 1.91)) };
  const tres = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), origin: useRef(new THREE.Vector3(5, -10, 0.05)) };
  const cuatro = { outer: useRef<THREE.Group>(null), inner: useRef<THREE.Group>(null), origin: useRef(new THREE.Vector3(-6.39, -11.8, -1.49)) };

  useConvergeAnimation([
    { ref: uno.inner, origin: uno.origin },
    { ref: dos.inner, origin: dos.origin },
    { ref: tres.inner, origin: tres.origin },
    { ref: cuatro.inner, origin: cuatro.origin }
  ]);

  useFloatAnimation([uno.outer, dos.outer, tres.outer, cuatro.outer]);

  return (
    <>
      <group ref={uno.outer}>
        <Apple ref={uno.inner} type="quarter" position={uno.origin.current} rotation={[1.8, 1.4, -0.3]} />
      </group>

      <group ref={dos.outer}>
        <Apple ref={dos.inner} type="quarter" position={dos.origin.current} rotation={[1.08, 3.67, 0.22]} />
      </group>

      <group ref={tres.outer}>
        {md && <Apple ref={tres.inner} type="half" scale={2} position={tres.origin.current} rotation={[0.9, -1.72, 0]} />}
      </group>

      <group ref={cuatro.outer}>
        {md && <Apple ref={cuatro.inner} type="quarter" position={cuatro.origin.current} rotation={[-3.14, -3.82, -3.58]} />}
      </group>
    </>
  );
}

export default SwirlApples;